/** @jsxImportSource @emotion/react */

import { useLingui } from '@lingui/react/macro';
import { CircleHelp, Minus, Plus } from 'lucide-react';
import { useSelector } from 'react-redux';

import EmptyButton from 'ud-ui/components/empty-button';
import useZoom from 'modules/overlay-canvas/hooks/use-zoom';
import UDTippy from 'ud-ui/components/tippy';
import { selectFabricManager } from 'modules/template-editor/store/editor/selectors';
import useTipModal from 'modules/template-editor/ui/hooks/modals/tip';
import { ZoomContainer } from './styles';

export function Zoom() {
  const { t } = useLingui();
  const manager = useSelector(selectFabricManager);
  const { increaseZoom, reduceZoom, zoom } = useZoom(manager);
  const { modal, open } = useTipModal();

  return (
    <ZoomContainer>
      <EmptyButton onClick={reduceZoom} icon={<Minus size={16} />} />
      {zoom}%
      <EmptyButton onClick={increaseZoom} icon={<Plus size={16} />} />
      <UDTippy content={t`Подсказки по управлению`} placement={'top'}>
        <EmptyButton onClick={open} icon={<CircleHelp size={16} />} />
      </UDTippy>
      {modal}
    </ZoomContainer>
  );
}
